module.exports = __webpack_public_path__ + "img/exit.cc059fe8.svg";